import React from 'react';

function AnimationAboutHeaderTitle({children}) {
    return (
        <h2 className="AnimationAboutHeaderTitle">{children}</h2>
    );
}

export default AnimationAboutHeaderTitle;
